import getNextWebWorkerJobId from "./getNextWebWorkerJobId"
import getWebWorkerJobsList, { type WebWorkerJobListItem } from "./getWebWorkerJobsList"
import type { JobResultDataUnion } from "./JobDataUnion.type"

export default function dispatchPromiseBasedJob<T extends JobResultDataUnion>(
  worker: Worker,
  data: object,
  transfer?: Transferable[],
): Promise<T> {
  // console.log('dispatchPromiseBasedJob')
  const jobId = getNextWebWorkerJobId()
    ; (data as { j?: number }).j = jobId
  const promise: Promise<T> = new Promise<T>((resolve, reject): void => {
    const workerJobsList = getWebWorkerJobsList<T>(worker)
    const workerJob : WebWorkerJobListItem<T> = { j: jobId, resolve, reject }
    workerJobsList.push(workerJob)
    // setTimeout(() => {
    worker.postMessage(data, transfer)
    // }, (Math.random() * 100) | 0)
  })
  return promise
}
